// extracted by mini-css-extract-plugin
export var icon = "_51-1";
export var subtext = "_51-0";